"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var _styled_1 = require("../../styled-components");
var styled_components_1 = __importDefault(require("styled-components"));
var CTAButton_1 = __importDefault(require("../call-to-action/CTAButton"));
var _interfaces_1 = require("../../interfaces");
var Text_1 = __importDefault(require("./Text"));
var DescriptionIcon_1 = __importDefault(require("./DescriptionIcon"));
var Image_1 = __importDefault(require("./Image"));
var Hr_1 = __importDefault(require("./Hr"));
var VideoPlayer_1 = __importDefault(require("./VideoPlayer"));
var Dots_1 = __importDefault(require("./Dots"));
var react_lazyload_1 = __importDefault(require("react-lazyload"));
var OuterContainer = styled_components_1.default(_styled_1.DefaultStyled)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  flex-direction: ", ";\n  @media (max-width: ", ") {\n    flex-direction: ", ";\n  }\n  @media (max-width: ", ") {\n    flex-direction: ", ";\n  }\n  @media (max-width: ", ") {\n    flex-direction: ", ";\n  }\n  @media (max-width: ", ") {\n    flex-direction: ", ";\n  }\n"], ["\n  display: ", ";\n  flex-direction: ",
    ";\n  @media (max-width: ", ") {\n    flex-direction: ",
    ";\n  }\n  @media (max-width: ", ") {\n    flex-direction: ",
    ";\n  }\n  @media (max-width: ", ") {\n    flex-direction: ",
    ";\n  }\n  @media (max-width: ", ") {\n    flex-direction: ",
    ";\n  }\n"])), function (_a) {
    var variant = _a.variant;
    return (variant ? 'flex' : '');
}, function (_a) {
    var variant = _a.variant;
    return variant === _interfaces_1.AvailableContainerBoxVariants.Reverse ? 'row-reverse' : '';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointWidescreen;
}, function (_a) {
    var variant = _a.variant;
    return variant === _interfaces_1.AvailableContainerBoxVariants.ReverseWidescreen
        ? 'column-reverse'
        : '';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointDesktop;
}, function (_a) {
    var variant = _a.variant;
    return variant === _interfaces_1.AvailableContainerBoxVariants.ReverseDesktop
        ? 'column-reverse'
        : '';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointTablet;
}, function (_a) {
    var variant = _a.variant;
    return variant === _interfaces_1.AvailableContainerBoxVariants.ReverseTablet
        ? 'column-reverse'
        : '';
}, function (_a) {
    var theme = _a.theme;
    return theme.breakpointMobile;
}, function (_a) {
    var variant = _a.variant;
    return variant === _interfaces_1.AvailableContainerBoxVariants.ReverseMobile
        ? 'column-reverse'
        : '';
});
var ConditionalLazyLoad = function (_a) {
    var lazyConfig = _a.lazyConfig, _b = _a.children, children = _b === void 0 ? null : _b;
    return lazyConfig ? react_1.default.createElement(react_lazyload_1.default, __assign({}, lazyConfig), children) : children;
};
var ContainerBox = function (_a) {
    var variant = _a.variant, classNames = _a.classNames, _b = _a.containers, containers = _b === void 0 ? [] : _b, defaultCss = _a.defaultCss, nativeProps = _a.nativeProps, padding = _a.padding, margin = _a.margin, fontSize = _a.fontSize, lazyConfig = _a.lazyConfig, ctaClicked = _a.ctaClicked;
    var renderItem = function (container) {
        var type = container.type;
        if (type === 'text')
            return react_1.default.createElement(Text_1.default, __assign({}, container.config));
        if (type === 'image')
            return react_1.default.createElement(Image_1.default, __assign({}, container.config));
        if (type === 'cta')
            return (react_1.default.createElement(CTAButton_1.default, __assign({}, container.config, { onClick: ctaClicked })));
        if (type === 'textWithIcon')
            return (react_1.default.createElement(DescriptionIcon_1.default, __assign({}, container.config)));
        if (type === 'hr')
            return react_1.default.createElement(Hr_1.default, __assign({}, container.config));
        if (type === 'dots')
            return react_1.default.createElement(Dots_1.default, __assign({}, container.config));
        if (type === 'video')
            return (react_1.default.createElement(VideoPlayer_1.default, __assign({}, container.config)));
        if (type === 'component') {
            var Component = container.component;
            return react_1.default.createElement(Component, __assign({}, container.config));
        }
    };
    var renderContainers = function () {
        return containers.map(function (container, index) {
            var _a;
            var key = "containerbox_" + index + "_" + containers.length + "}";
            if ((_a = container.containers) === null || _a === void 0 ? void 0 : _a.length) {
                return react_1.default.createElement(ContainerBox, __assign({ key: key }, container, { ctaClicked: ctaClicked }));
            }
            return (react_1.default.createElement(ConditionalLazyLoad, { key: key, lazyConfig: container.lazyConfig }, renderItem(container)));
        });
    };
    return (react_1.default.createElement(ConditionalLazyLoad, { lazyConfig: lazyConfig },
        react_1.default.createElement(OuterContainer, __assign({ className: classNames, variant: variant, defaultCss: defaultCss, padding: padding, margin: margin, fontSize: fontSize }, nativeProps), containers.length > 0 && renderContainers())));
};
exports.default = ContainerBox;
var templateObject_1;
//# sourceMappingURL=ContainerBox.js.map